import { render, staticRenderFns } from "./Dialog_ChooseCoupon.vue?vue&type=template&id=0bd7baa4&scoped=true&"
import script from "./Dialog_ChooseCoupon.vue?vue&type=script&lang=js&"
export * from "./Dialog_ChooseCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd7baa4",
  null
  
)

export default component.exports